import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Download, AlertTriangle, Sparkles } from 'lucide-react';

// CCV / adendas / otros efectivos de la entrega: identificación guardada, o lo enviado por el CRM.
export const documentosEfectivos = (entrega) => {
  const ident = entrega?.crm_documentos_identificados;
  if (ident) {
    return {
      contrato: ident.contrato || null, adendas: ident.adendas || [], otros: ident.otros || [],
      metodo: ident.metodo, estado: ident.estado, mensaje: ident.mensaje, limites: ident.limites,
    };
  }
  const docs = entrega?.crm_documentos || {};
  const posteriores = (docs.posteriores_al_contrato || []).filter(d => d?.url);
  if (docs.contrato_compraventa?.url) {
    return { contrato: docs.contrato_compraventa, adendas: posteriores, otros: [], metodo: 'crm', estado: 'identificado' };
  }
  return { contrato: null, adendas: [], otros: posteriores, metodo: null, estado: posteriores.length ? 'pendiente' : null };
};

const DocLink = ({ doc, testid, fallback }) => (
  <a href={doc.url} target="_blank" rel="noopener noreferrer" data-testid={testid}
    className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-800 hover:underline break-all">
    <Download size={14} className="shrink-0" />
    {doc.nombre || fallback}
  </a>
);

const Seccion = ({ titulo, children, testid }) => (
  <div className="space-y-1" data-testid={testid}>
    <p className="text-[11px] font-semibold uppercase tracking-wide text-[#888]">{titulo}</p>
    {children}
  </div>
);

const AVISOS = {
  sin_ccv: 'No se identificó el Contrato de Compraventa',
  varios_ccv: 'Varios posibles CCV',
  error: 'No se pudieron analizar los documentos',
  pendiente: 'El CCV no vino identificado desde el CRM; se identificará por contenido',
};

export const DocumentosCRMCard = ({ entrega }) => {
  if (!entrega?.crm_documentos || Object.keys(entrega.crm_documentos).length === 0) return null;
  const d = documentosEfectivos(entrega);
  const aviso = AVISOS[d.estado];
  return (
    <Card className="border border-[#E8E8E7]" data-testid="card-documentos-crm">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <CardTitle className="text-sm font-semibold text-[#4E7A79]">Documentos CRM</CardTitle>
          {d.metodo === 'ia' && (
            <Badge variant="outline" className="text-[10px] border-[#4E7A79] text-[#4E7A79]" data-testid="badge-identificado-contenido">
              <Sparkles size={10} className="mr-1" /> identificado por contenido
            </Badge>
          )}
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        {aviso && (
          <div className="flex items-start gap-2 rounded-md bg-amber-50 border border-amber-200 p-2 text-xs text-amber-800" data-testid="aviso-documentos">
            <AlertTriangle size={14} className="shrink-0 mt-0.5" />
            <span>{d.mensaje || aviso}</span>
          </div>
        )}
        {d.limites?.excedido && (
          <div className="flex items-start gap-2 rounded-md bg-amber-50 border border-amber-200 p-2 text-xs text-amber-800" data-testid="aviso-limite-documentos">
            <AlertTriangle size={14} className="shrink-0 mt-0.5" />
            <span>{d.limites.mensaje}</span>
          </div>
        )}
        {d.contrato && (
          <Seccion titulo="Contrato de Compraventa" testid="seccion-ccv">
            <DocLink doc={d.contrato} testid="link-contrato-pdf" fallback="Contrato de Compraventa" />
          </Seccion>
        )}
        {d.adendas.length > 0 && (
          <Seccion titulo="Adendas" testid="seccion-adendas">
            {d.adendas.map((doc, i) => <DocLink key={doc.url} doc={doc} testid={`link-adenda-pdf-${i}`} fallback={`Adenda ${i + 1}`} />)}
          </Seccion>
        )}
        {d.otros.length > 0 && (
          <Seccion titulo={d.contrato ? 'Otros documentos' : 'Documentos del CRM (sin CCV identificado)'} testid="seccion-otros">
            {d.otros.map((doc, i) => <DocLink key={doc.url} doc={doc} testid={`link-otro-pdf-${i}`} fallback={`Documento ${i + 1}`} />)}
          </Seccion>
        )}
      </CardContent>
    </Card>
  );
};

export default DocumentosCRMCard;
